// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"
import { rgba } from "polished"

export const TableLink = styled.div`
  > a {
    color: inherit;
    font-weight: bold;
    text-decoration: none;
  }
`

export const TableContainer = styled.div`
  margin-bottom: 40px;
  overflow: auto;
  position: relative;
`

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0 5px;
  margin: 0;
  width: 100%;
  table-layout: fixed;
  min-width: 400px;
`

export const Th = styled.th<{ $sticky?: boolean }>`
  border: none;
  color: ${colors.gray3};
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  padding: 0 15px 15px 15px;
  white-space: nowrap;

  ${({ $sticky }) =>
    $sticky &&
    `
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: ${colors.white};
    `}

  &:first-child {
    padding-left: 15px;
  }

  &:last-child {
    padding-right: 15px;
  }
`

export const Tr = styled.tr<{ isClickable?: boolean }>`
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};
  background-color: #fbfbfd;
  height: 55px;

  &:hover {
    background-color: ${rgba(colors.blue2, 0.1)};
    transition: background-color 0.2s ease-in-out;
  }
`

export const Td = styled.td`
  border-bottom: solid 1px ${colors.gray2};
  border-top: solid 1px ${colors.gray2};
  padding-left: 15px;
  padding-right: 15px;
  white-space: nowrap;
  background-color: inherit;

  &:first-child {
    border-left: solid 1px ${colors.gray2};
    padding-left: 15px;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
  }

  &:last-child {
    border-right: solid 1px ${colors.gray2};
    padding-right: 15px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }

  > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .react-loading-skeleton {
    line-height: 18px;
  }

  .skeleton-status {
    border-radius: 50%;
    line-height: 11px;
    width: 11px;
  }

  .skeleton-image {
    line-height: 50px;
  }

  &.pinned {
    background-color: ${colors.lightBlue2};
  }
`

export const NoTableData = styled.div`
  margin: 2.5rem 0;
  text-align: center;
`

export const TableActionButton = styled.span`
  cursor: pointer;
  display: inherit;
  line-height: 100%;
`

export const TableTopGroup = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  text-align: right;

  &.right {
    justify-content: flex-end;
  }
`
